import { ThemeProvider } from '@ori-ui/mui';
import { TestIdProvider } from '@ori/testid-generator';
import type { VFC } from 'react';
import { I18nextProvider } from 'react-i18next';

import { BubbleGroup } from './components';
import { i18n } from './helpers';
import { DEFAULT_TRANSLATIONS } from './models';

export interface Config {
  tenant: string;
}
interface AppProps {
  config: string;
  isECatalogue: boolean;
}

export const App: VFC<AppProps> = ({ config, isECatalogue }) => {
  if (!config) {
    throw new Error('No config provided!');
  }
  const { tenant } = JSON.parse(config) as Config;
  if (!tenant) {
    throw new Error('Missing config values!');
  }

  const keys = Object.values(DEFAULT_TRANSLATIONS);
  const translations = i18n(`${window.location.origin}/system/ajax/Localization/Translate`, keys);

  return (
    <ThemeProvider enableCacheProvider cacheKey="basket-bubble">
      <I18nextProvider i18n={translations}>
        <TestIdProvider team="Checkout" project="basket-bubble">
          <BubbleGroup isECatalogue={isECatalogue} />
        </TestIdProvider>
      </I18nextProvider>
    </ThemeProvider>
  );
};
